import { type MainTranslationFunction } from '@autone/translations';

import { type APP_NAME } from '../../../../consts';
import { type AssortmentCustomColumnsConfig } from '../AssortmentCustomColumnsMenu.types';

export const getProductsTableCustomColumnsConfig = (
  t: MainTranslationFunction<typeof APP_NAME>,
): AssortmentCustomColumnsConfig<'productsTable'> => {
  return {
    storageKey: 'productsTable.extrasMenu.customColumns',
    columnOptions: [
      {
        id: 'permanent',
        translatedDisplayName: t('custom-columns-groups.permanent'),
        columns: [
          {
            id: 'product_name',
            translatedDisplayName: t('table-columns.product-name'),
          },
        ],
      },
      {
        id: 'attributes',
        translatedDisplayName: t('custom-columns-groups.attributes'),
        columns: [
          {
            id: 'product_groups',
            translatedDisplayName: t.withCustomer(
              'table-columns.$product-groups',
            ),
          },
        ],
      },
      {
        id: 'assortment',
        translatedDisplayName: t('custom-columns-groups.assortment'),
        columns: [
          {
            id: 'locations_assorted',
            translatedDisplayName: t('table-columns.locations-assorted'),
          },
          {
            id: 'perc_locations_assorted',
            translatedDisplayName: t('table-columns.perc-locations-assorted'),
          },
          {
            id: 'initial_allocation',
            translatedDisplayName: t('table-columns.initial-allocation'),
          },
        ],
      },
      {
        id: 'sales',
        translatedDisplayName: t('custom-columns-groups.sales'),
        columns: [
          {
            id: 'total_sales_units',
            translatedDisplayName: t('table-columns.total-sales-units'),
          },
          {
            id: 'total_sales_value',
            translatedDisplayName: t('table-columns.total-sales-value'),
          },
          {
            id: 'first_sale_date',
            translatedDisplayName: t('table-columns.first-sale-date'),
          },
          {
            id: 'latest_sale_date',
            translatedDisplayName: t('table-columns.latest-sale-date'),
          },
        ],
      },
      {
        id: 'inventory',
        translatedDisplayName: t('custom-columns-groups.inventory'),
        columns: [
          {
            id: 'store_units',
            translatedDisplayName: t('table-columns.store-units'),
          },
          {
            id: 'warehouse_units',
            translatedDisplayName: t('table-columns.warehouse-units'),
          },
          {
            id: 'warehouse_pending_from_production_units',
            translatedDisplayName: t(
              'table-columns.warehouse-pending-from-production-units',
            ),
          },
        ],
      },
    ],
    columnPinning: {
      leftPinned: ['product_name'],
    },
    permanentColumns: ['product_name'],
  } as const;
};
